import React from "react";

const MarkdownRenderer = ({ markdown }) => {
    return markdown.split("\n").map((line, index) => {
        if (line.startsWith("# ")) {
            return (
                <h1
                    key={index}
                    className="text-3xl md:text-4xl font-extrabold mt-8 mb-4 
                    text-gray-900 dark:text-slate-50 tracking-tight"
                >
                    {line.substring(2)}
                </h1>
            );
        }

        if (line.startsWith("## ")) {
            return (
                <h2
                    key={index}
                    className="text-2xl md:text-3xl font-bold mt-6 mb-3 
                    text-gray-900 dark:text-slate-50"
                >
                    {line.substring(3)}
                </h2>
            );
        }

        if (line.startsWith("### ")) {
            return (
                <h3
                    key={index}
                    className="text-xl md:text-2xl font-semibold mt-4 mb-2 
                    text-gray-900 dark:text-slate-50"
                >
                    {line.substring(4)}
                </h3>
            );
        }

        if (line.startsWith("* ") || line.startsWith("- ")) {
            return (
                <li
                    key={index}
                    className="mb-1 ml-6 list-disc 
                    text-gray-800 dark:text-slate-200 leading-relaxed"
                >
                    {line.substring(2)}
                </li>
            );
        }

        if (line.trim() === "") return null;

        return (
            <p
                key={index}
                className="mb-4 
                text-gray-800 dark:text-slate-200 
                leading-relaxed text-[15px] md:text-base"
            >
                {line}
            </p>
        );
    });
};

export default MarkdownRenderer;
